const normalize = (num: number, scale: number = 1000) => Math.round(num * scale);

/** Tries to handle floating point errors. */
export const safeRemainder = (a: number, b: number, scale: number = 1000): number => {
    return normalize(a, scale) % normalize(b, scale) / scale;
};

export const safeAdd = (a: number, b: number, scale: number = 1000): number => {
    return (normalize(a, scale) + normalize(b, scale)) / scale;
};

export const safeMultiply = (a: number, b: number, scale: number = 1000): number => {
    return normalize(a, scale) * normalize(b, scale) / (scale * scale);
};

export const safeDivide = (a: number, b: number, scale: number = 1000): number => {
    if (b === 0) {
        throw new Error('Division by zero');
    }
    return normalize(a, scale) / normalize(b, scale);
};
